import SodMitigateModal from './SodMitigateModal';

export default SodMitigateModal;
